<template>
	<div class="Cellraspred">
		
		<!--div><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/></div-->
		<div class="filter-tag-row"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/><span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">{{this.masObjects_count}}</span></div>
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			name="cellraspred"
			/>
		</div>
		
		<card>
			<div class="pb-3">
				<h5><i class="tim-icons icon-send text-success mr-3"></i>Распределить ячейку</h5>
			</div>
			<div>
				<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Распределить" />
			</div>
		</card>
		<card class="Cellraspred-table col-sm-12 "
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	>
			<el-table :data="ApiData" style="width: 100%;">				
				<el-table-column
				label="ID"
				property="id"
				width="80"
				sortable
				
				></el-table-column>
				<el-table-column 
				min-width="180"
				label="Название ячейки"
				property="cellName"
				sortable
				></el-table-column>
				<!--el-table-column
				min-width="180"
				label="Координаты ячейки"
				prop="cellValues"
				><template slot-scope="scope">						
						<button class="ml-3 btn btn-simple btn-primary" @click="showThisCell(scope.$index, scope.row)">
							<i class="tim-icons icon-square-pin"></i>
							Показать на карте
						</button>
					</template>
				</el-table-column-->
				<el-table-column
				label="Ответственный"
				sortable
				min-width="200"
				prop="agentName"
				>
				<!--
					<template slot-scope="scope">
					<ReInputSearchDrop
					findId="agent_id"
					placeholder="Выбрать ответсвенного"
					:value="{'inputText':scope.row.agentName,'selectedVal':scope.row.agentId}"
					:objApiMethod="{'obj':'staff' ,'flt':{'fio':''}}"
					strApiMethodKey="fio"
					@change="onAgentChange($event, scope.row)"
					/>
					</template>
				-->
					<template v-slot="scope">
						<router-link :to="`/data/staff/id/${scope.row.agentId}`">{{scope.row.agentName}}</router-link>
					</template>
				</el-table-column>
				<el-table-column
				label="Класс жилья"
				prop="masClasses"
				min-width="180"
				>
				<template v-slot="scope">
					<el-select						
					class="col-md px-0 select-primary  overflow-overlay"						
					multiple
					placeholder="Класс жилья"
					size="large"
					v-model="scope.row.houseClassList"
					>
						<el-option
							class="select-primary long-select"
							v-for="option in masClasses"
							:key="option.label"
							:label="option.label"
							:value="option.value"
						></el-option>
					</el-select>
				</template>
				</el-table-column>
				<el-table-column
				label="Тип жилья"
				prop="masHouseTypies"
				min-width="250"
				>
				<template v-slot="scope">
					<ReSelectCascadeObjCategory
						v-model="scope.row"
					/>
				</template>
				</el-table-column>
				<!--el-table-column 
				min-width="180"
				label="Количество объектов"
				property=""
				sortable
				>кол-во</el-table-column-->
				<el-table-column
				label="Кто распределил"
				prop="WhoDistributedFio"
				min-width="250"
				>
				<template v-slot="scope">
					<router-link :to="`/data/staff/id/${scope.row.WhoDistributedId}`">{{scope.row.WhoDistributedFio}}</router-link>
				</template>
				</el-table-column>

				<el-table-column
					label="Дата распределения"
					prop="InsertTime"
					min-width="160"
				>
				<template v-slot="scope">
					{{$GVO.convertDateTimeFromMysql(scope.row.InsertTime)}}
				</template>
				</el-table-column>
				
				
				<el-table-column
					width="160"
					label="Действие"
					align="right"                    	
				>
					<template v-slot="scope">			
						<el-tooltip content="Сохранить изменения" placement="top">
							<el-button class="no-border my-0">
								<button class="ml-3 btn btn-icon btn-simple btn-success" @click="UpdateCell(scope.row)">
									<i class="tim-icons icon-book-bookmark"></i>
								</button>											
							</el-button>
						</el-tooltip>		
						<el-tooltip content="Удалить распределение" placement="top">
							<el-button class="no-border my-0">
								<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="DeleteCell(scope.row)">
									<i class="tim-icons icon-trash-simple"></i>
								</button>											
							</el-button>
						</el-tooltip>		
					</template>
				</el-table-column>
			</el-table>
			<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)*parseInt(count2page)" 
				:perPage="parseInt(count2page)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>
		</card>
	</div>
</template>
<script>


import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
// import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";
import Pagination from 'src/our_components/RePagination';
import ReSelectCascadeObjCategory from 'src/our_components/ReSelectCascadeObjCategory.vue';
// import { Loading } from 'element-ui';

export default {
	name: 'cellraspred-page',
	components: {
		[Table.name]: Table,
    	[TableColumn.name]: TableColumn,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tooltip.name]: Tooltip,	
		[Button.name]: Button,
		ReFilterBtn,
		ReFilter,
		ReFormPrinter,
		// ReInputSearchDrop,
		Pagination,
		ReSelectCascadeObjCategory,
		// Loading
	},
	data() {
		return {
			ApiData: [],
			bShowFilter: false,
			objGetParams:{},
			masObjects_total: 0,
			masObjects_count: 0,
			count2page: 10,
			masAllFilterParams: this.currentFilterConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			masAllFormParams: this.currentFormConfig(),
			//masAllFormParamsTest: this.currentFormConfigTest(),
			masClasses: [{value: '1', label: 'Стандарт'}, {value: '2', label: 'Бизнес'}, {value: '3', label: 'Комфорт'}],
			masHouseTypies: [{value: '1', label: 'Квартира'}, {value: '2', label: 'Комната'}, {value: '3', label: 'Дом'}, {value: '4', label: 'Участок'}, {value: '5', label: 'Коммерция'}],
			masRooms: [{value: '1', label: 'Студия'}, {value: '2', label: '1ккв'}, {value: '3', label: '2ккв'}, {value: '4', label: '3ккв'}, {value: '5', label: '4ккв'}],
			fullscreenLoading: false,
		};
	},
	methods: {
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			this.$GVO.ApiCall('CELLS_STAFF.GET',{flt:{...{act:1}, ...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						this.masObjects_total = objApi.countpage;
						this.masObjects_count = objApi.total;
					}else{
						this.ApiData = [];
						this.masObjects_total=0;
						this.masObjects_count = 0;
					}
				}else{
					this.ApiData = [];
					this.masObjects_total=0;
					this.masObjects_count = 0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; this.masObjects_count = 0; console.error(errorObjApi);});
		},
		currentFilterConfig(){
			//return require("src/conf/cellraspredFilter.js").super_config;
			this.$GVO.ApiCall('CELLS_STAFF.GET_FILTER',{})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						//console.log(objApi.config[0].elements[objApi.config[0].elements.length-1]);
						this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentFormConfigTest() {
			return require("src/conf/cellraspredForm.js").post_config;
		},
		currentApiFormMethodComp(){
			return {apiMethod:'CELLS_STAFF.INS',apiParam:{iData:[]}};
		},
		currentFormConfig() {
			this.$GVO.ApiCall('CELLS_STAFF.GET_FORM_MODEL',{})
				.then((objApi) => {
					if(objApi.success){
						// console.log('124');
						this.masAllFormParams = objApi.config;
						//this.initAddrSearch();
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		initAddrSearch(){
			// console.log('addr',this.$refs);
			// setTimeout(()=>{console.log('addr2',this.$refs);},1000)
		},
		onAgentChange(evt,row){
			//console.log(evt,row);
			row.agentId = evt.selectedVal;
			row.agentName = evt.inputText;
		},
		showThisCell(index, row){
			// console.log(index, row);
		},
		SuccessGo(evt,dopParam){
			//console.log(evt,dopParam);
			this.masAllFormParams = this.currentFormConfig();
			this.OnFilterApply();
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){
			//console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"houseTypeList":"","houseRoomsList":""}') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"houseTypeList":"","houseRoomsList":[]}') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},
		UpdateCell(row){
			//console.log(row);
			if(row.id != null){
				this.$GVO.ApiCall('CELLS_STAFF.UPD',{ flt:{id: row.id},uData:{
					'agentId': row.agentId, 
					'agentName': row.agentName,
					'cellValues': row.cellValues, 
					'houseClassList': row.houseClassList,
					'houseRoomsList': row.houseRoomsList,
					'houseTypeList': row.houseTypeList
					}}).then((objApi) => {
						//console.log(objApi);
						if(objApi.success === true){
							this.getApiData();
							this.openFullScreen1();
						}else{
							alert('Не сохранилось. Возможно у вас нет доступа на изменение');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}

		},
		DeleteCell(row){
			//console.log(row);
			if(row.id != null){
				this.$GVO.ApiCall('CELLS_STAFF.DEL',{ flt:{id: row.id}}) 
					.then((objApi) => {
						//console.log(objApi);
						if(objApi.success === true){
							this.getApiData();
						}else{
							alert('Не удалилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		},
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 10000);
		},
	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style>
.Cellraspred .bntGroup {
	display: flex;
	justify-content: flex-end;
}
.Cellraspred .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: center;
	flex-wrap: wrap;
}
.Cellraspred .form-group {
	margin-bottom: 0px!important;
}
.Cellraspred-table .cell, .Cellraspred-table button {
	word-break: break-word!important;
}
.Cellraspred .ReSelectCascade {display: flex;flex-direction: row;}
.Cellraspred .ReSelectCascade .row {margin-right: 1px;}
#houseClassList, #addr {margin-right: 5px;}

@media (max-width: 670px) {	
		#houseClassList {
			margin-bottom: 7px!important;
		}
	}

</style>
